module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iMsg4"))).then(() => parcelRequire('dJXJK'));